import React, { PropsWithChildren } from 'react'

import { ModalData } from '@context/ModalsContext'

import { ModalBody } from './Body'
import { ModalContainer, ModalContainerProps } from './Container'
import { ModalFooter } from './Footer/ModalFooter'
import { ModalGrid } from './Grid/ModalGrid'
import { ModalHeader } from './Header/ModalHeader'
import { ModalWrapper } from './Wrapper'

type ModalCompound = React.FC<ModalContainerProps> & {
  Header: typeof ModalHeader
  Grid: typeof ModalGrid
  Body: typeof ModalBody
  Footer: typeof ModalFooter
  Wrapper: typeof ModalWrapper
  Popup: React.FC<ModalContainerProps>
  FullScreen: React.FC<ModalContainerProps>
}

export const Modal = Object.assign(ModalContainer, {
  Header: ModalHeader,
  Grid: ModalGrid,
  Body: ModalBody,
  Footer: ModalFooter,
  Wrapper: ModalWrapper,
  Popup: (props: PropsWithChildren<ModalData>) => <ModalContainer {...props} mode='popup' />,
  FullScreen: (props: PropsWithChildren<ModalData>) => (
    <ModalContainer {...props} mode='fullScreen' />
  ),
}) as ModalCompound
